module.exports = __webpack_public_path__ + "static/img/end.24afe65.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/Smena7/end.jpg
// module id = 4RsK
// module chunks = 1